const documentTypeIds = {
  Folder: -1,
  Offer: -5,
  OfferImage: -8,
  FacilityFrameOffer: -13,
  FacilityFrameOfferImage: -14,
  FacilityApproval: -15,
  OfferModification: -11,
  Facility: -10,
  PartnerFile: -18
};

export default documentTypeIds;
